import type { IObjectiveProductRequirementsAssetFinance } from './ObjectiveProductRequirementsAssetFinance.interface';
import { ObjectivePayBallonOption } from './ObjectivePayBallonOption.enum';
import { ObjectivePaymentPreferenceOption } from './ObjectivePaymentPreferenceOption.enum';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveProductRequirementsAssetFinance
  implements IObjectiveProductRequirementsAssetFinance {
  loanAmount: number;
  loanTerm: number;
  balloonPercent: number;
  payBalloon: ObjectivePayBallonOption;
  paymentsPreference: ObjectivePaymentPreferenceOption;
  paymentFrequency: PaymentFrequency;
  capitaliseFees: YesNoOption;

  static build = (data: IObjectiveProductRequirementsAssetFinance) =>
    new ObjectiveProductRequirementsAssetFinance(data);

  static blank = () => new ObjectiveProductRequirementsAssetFinance();

  /**
   * Constructor
   * @param {IObjectiveProductRequirementsAssetFinance} data
   */
  constructor(data?: IObjectiveProductRequirementsAssetFinance) {
    this.loanAmount = parseFloat(data?.loanAmount || 0);
    this.loanTerm = parseFloat(data?.loanTerm || 0);
    this.balloonPercent = parseFloat(data?.balloonPercent || 0);
    this.payBalloon = ObjectivePayBallonOption.of(
      data?.payBalloon?.name || data?.payBalloon?.toString()
    );
    this.paymentsPreference = ObjectivePaymentPreferenceOption.of(
      data?.paymentsPreference?.name || data?.paymentsPreference?.toString()
    );
    this.paymentFrequency = PaymentFrequency.of(
      data?.paymentFrequency?.name || `o${data?.paymentFrequency}`
    );
    this.capitaliseFees = YesNoOption.of(
      data?.capitaliseFees?.name || data?.capitaliseFees?.toString()
    );
  }
}
